import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/goalsSlice";

import goalsApis from "src/api/goals";

import { common } from "src/types/index";
import { constants } from "src/constants/common";

// get goals saga
const GetGoalsSaga = function* GetGoalsSaga({
  payload: { resolve, reject, payload },
}: {
  payload: {
    payload: {
      user_id: string;
    };
    resolve: (response: any) => void;
    reject: (error: any) => void;
  };
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      goalsApis.getGoals,
      payload
    );

    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.getGoalsSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.getGoalsError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// set goals saga
const SetGoalsSaga = function* SetGoalsSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      goalsApis.setGoals,
      payload
    );

    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.setGoalsSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.setGoalsError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

export default function* goalsSaga() {
  yield all([
    takeEvery(actions.getGoalsRequest, GetGoalsSaga),
    takeEvery(actions.setGoalsRequest, SetGoalsSaga),
  ]);
}
